
<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-3"><h4><b>{{ "pages.createReceiptPage.categoryPage.category" | translate }}</b></h4></div>
    <div [@openClose]="!isOpen ? 'open' : 'closed'">
      <div class="col-sm-3"><h4>{{selectedCategory.Description}}</h4></div>
      <!--<div class="col-sm-3"><h4>{{selectedCategory}}</h4></div>-->
      <div class="col-sm-3"><h4 class="change" (click)="change()">{{ "common.change" | translate }}</h4></div>
    </div>
  </div>
</div>
<div class="mrgin-lft" [@openClose]="isOpen ? 'open' : 'closed'">
  <div *ngFor="let category of receiptSubTypes; index as i" class="col-md-3 col-lg-3 col-sm-10">
    <button class="btn btn-mode" (click)="selecteCategory(category)">
       {{category.Description}}
    </button>
  </div>
</div>



